import React from 'react'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Pareto from 'highcharts/modules/pareto';
import SolidGauge from 'highcharts/modules/solid-gauge';
import Highcharts from "@material-ui/core/es/styles/withStyles";
import Card from "../../common/Card";

HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);

// Radialize the colors



export default function AplicacacoBandaColaVerdePieChart(prop) {
    const { series, title } = prop;

    let ser = [];
    let dril = [];

    console.log("colaverde series", series)

    if (series) {
        series.map(s => {
            if (s.geral == "n/d") return null;

            let xser = ser.findIndex( ss => ss.name ===  s.geral );
            if (xser >= 0) {
                ser[xser].y = ser[xser].y + 1
            } else { ser.push({ name: s.geral, y: 1, drilldown: s.geral }) }

            let xdril = dril.findIndex( sd => sd.name ===  s.geral );
            if (xdril >= 0) {
                let xxdat = dril[xdril].data.findIndex( id => id[0] === s.grupo );
                if (xxdat >= 0) {
                    dril[xdril].data[xxdat][1] = dril[xdril].data[xxdat][1] + 1
                } else {
                    dril[xdril].data.push([s.grupo, 1])
                }
            } else { dril.push({ name: s.geral, id: s.geral, data: [[s.grupo, 1]]  }) }


        })
    }

    const configPie = {

            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },


            tooltip: {
                pointFormat: '{series.name}: <br>{point.percentage:.1f} %<br>value: {point.y}'
            },
            accessibility: {
                point: {
                    valueSuffix: ''
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    size: '100%',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>:<br>{point.percentage:.1f} %<br> qtde: {point.y}',
                        connectorColor: 'silver',
                        distance: 10,

                    }
                }
            },

            title: {
                enabled : true,
                text: title
            },
            series: [
                {
                    name: "Resultado",
                    colorByPoint: true,
                    data: ser
                }
            ],
            drilldown: {
                    series: dril
            }
        }


        console.log("piechart config", configPie);

    return (
        <Card>
            <ReactHighcharts config = {configPie}>
            </ReactHighcharts>
        </Card>
    )
}
